import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'RESET YOUR GOALS',
      subtitle: 'Build Strength, Transform Your Life',
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/35f8a9130d05baea37fc4c9ad02493b4.png'
    },
    {
      title: 'REBUILD YOUR HABITS',
      subtitle: 'Professional Training, Real Results',
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/1c6890044cc3edc4b049ea2e04ce8b97.png'
    },
    {
      title: 'PUSH BEYOND LIMITS',
      subtitle: "Kenya's Biggest Gym Awaits You",
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/0bfb3e9acbe05b7a40636e080f8a9c90.png'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-[85vh] lg:h-screen w-full overflow-hidden">
      {/* Slideshow Background */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            currentSlide === index ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/45"></div>
        </div>
      ))}

      {/* Small Membership Widget - Bottom Left */}
      <a
        href="#membership"
        className="absolute bottom-20 lg:bottom-24 left-4 lg:left-8 z-20 bg-gradient-to-br from-red-600/90 to-red-700/90 backdrop-blur-md border-2 border-red-500/50 rounded-lg lg:rounded-xl p-2 lg:p-4 shadow-2xl shadow-red-600/30 hover:scale-105 transition-all duration-300 cursor-pointer group"
      >
        <div className="flex items-center gap-2 lg:gap-3">
          <div className="w-8 h-8 lg:w-12 lg:h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <i className="ri-vip-crown-line text-white text-sm lg:text-2xl"></i>
          </div>
          <div>
            <p className="text-white/80 text-[8px] lg:text-xs font-semibold uppercase tracking-wider">Membership at only</p>
            <div className="flex items-baseline gap-1">
              <span className="text-white text-xs lg:text-xl font-black">KES 4,650</span>
              <span className="text-white/70 text-[8px] lg:text-xs">/month</span>
            </div>
          </div>
          <i className="ri-arrow-right-line text-white text-sm lg:text-xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
        </div>
      </a>

      {/* Quick Navigation Buttons - Top Right */}
      <div className="absolute top-24 right-6 lg:right-12 z-20 hidden lg:flex flex-col gap-3">
        <Button
          href="#about"
          variant="navigation"
          icon="ri-information-line"
          iconPosition="left"
        >
          About Us
        </Button>
        <Button
          href="#services"
          variant="navigation"
          icon="ri-heart-pulse-line"
          iconPosition="left"
        >
          Programs
        </Button>
        <Button
          href="#equipment"
          variant="navigation"
          icon="ri-tools-line"
          iconPosition="left"
        >
          Equipment
        </Button>
        <Button
          href="#testimonials"
          variant="navigation"
          icon="ri-star-line"
          iconPosition="left"
        >
          Reviews
        </Button>
        <Button
          href="#contact"
          variant="navigation"
          icon="ri-map-pin-line"
          iconPosition="left"
        >
          Location
        </Button>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center pt-16 lg:pt-0">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 w-full">
          <div className="max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-1.5 px-2 py-1 lg:px-4 lg:py-2 bg-red-600/20 border border-red-500/50 rounded-lg mb-3 lg:mb-6 backdrop-blur-sm">
              <div className="w-1.5 h-1.5 lg:w-2 lg:h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-red-400 text-[10px] lg:text-sm font-semibold tracking-wider">ONE OF KENYA'S BIGGEST GYMS</span>
            </div>

            {/* Main Title */}
            <h2 className="text-3xl lg:text-8xl font-black text-white mb-2 lg:mb-6 leading-tight tracking-tight">
              {slides[currentSlide].title}
            </h2>

            <p className="text-base lg:text-3xl text-gray-300 mb-4 lg:mb-8 font-light">
              {slides[currentSlide].subtitle}
            </p>

            {/* Stats - Compact on mobile */}
            <div className="grid grid-cols-4 gap-2 lg:flex lg:flex-wrap lg:gap-8 mb-4 lg:mb-10">
              <div>
                <div className="text-lg lg:text-4xl font-black text-red-500 mb-0 lg:mb-1">100+</div>
                <div className="text-gray-400 text-[9px] lg:text-sm uppercase tracking-wider">Machines</div>
              </div>
              <div>
                <div className="text-lg lg:text-4xl font-black text-red-500 mb-0 lg:mb-1">Pro</div>
                <div className="text-gray-400 text-[9px] lg:text-sm uppercase tracking-wider">Trainers</div>
              </div>
              <div>
                <div className="text-lg lg:text-4xl font-black text-red-500 mb-0 lg:mb-1">8+</div>
                <div className="text-gray-400 text-[9px] lg:text-sm uppercase tracking-wider">Programs</div>
              </div>
              <div>
                <div className="text-lg lg:text-4xl font-black text-red-500 mb-0 lg:mb-1">Free</div>
                <div className="text-gray-400 text-[9px] lg:text-sm uppercase tracking-wider">Screening</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-2 lg:gap-4 mb-4 lg:mb-8">
              <Button
                href="#membership"
                variant="cta"
                icon="ri-vip-crown-line"
                iconPosition="right"
                className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
              >
                Join Our Gym
              </Button>
            </div>
          </div>
        </div>

        {/* Monthly Subscription Widget - Right Side */}
        <div className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 translate-y-16 z-20">
          <div className="bg-gradient-to-br from-gray-900/30 via-black/30 to-gray-900/30 backdrop-blur-md border-2 border-red-600/50 rounded-2xl p-6 shadow-2xl shadow-red-600/20 w-72 transform hover:scale-105 transition-all duration-300">
            <div className="text-center">
              <div className="inline-block px-3 py-1 bg-red-600/20 border border-red-500/50 rounded-full text-red-400 text-xs font-bold uppercase tracking-wider mb-4">
                Monthly Membership
              </div>
              
              <p className="text-gray-300 text-sm mb-2">At only</p>
              
              <div className="flex items-baseline justify-center gap-1 mb-2">
                <span className="text-red-500 text-2xl font-bold">KES</span>
                <span className="text-white text-5xl font-black">4,650</span>
              </div>
              
              <p className="text-gray-400 text-xs uppercase tracking-wider mb-4">per month</p>
              
              <div className="h-px bg-gradient-to-r from-transparent via-red-600/50 to-transparent mb-4"></div>
              
              <div className="space-y-2 mb-5 text-left">
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-red-500 text-sm"></i>
                  <span className="text-gray-300 text-xs">Unlimited gym access</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-red-500 text-sm"></i>
                  <span className="text-gray-300 text-xs">Professional trainers</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-red-500 text-sm"></i>
                  <span className="text-gray-300 text-xs">Free fitness screening</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-check-line text-red-500 text-sm"></i>
                  <span className="text-gray-300 text-xs">Group class access</span>
                </div>
              </div>
              
              <Button
                href="#membership"
                variant="submit"
                icon="ri-arrow-right-line"
                iconPosition="right"
                className="w-full text-sm px-6 py-3"
              >
                Join Now
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-6 lg:bottom-12 left-1/2 -translate-x-1/2 z-20 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-1 rounded-full transition-all duration-300 cursor-pointer ${
              currentSlide === index ? 'w-8 lg:w-12 bg-red-600' : 'w-6 lg:w-8 bg-gray-600'
            }`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 right-12 z-20 hidden lg:flex flex-col items-center gap-2 text-gray-500">
        <span className="text-xs font-semibold rotate-90 mb-4 tracking-widest">SCROLL</span>
        <div className="w-px h-16 bg-gradient-to-b from-gray-600 to-transparent"></div>
      </div>
    </section>
  );
}
